import type { SessionUser } from "@resume-cloudflare/shared";
import { LogOut, MapPin, Settings as SettingsIcon, UserRound } from "lucide-react";
import { useNavigate } from "react-router";
import { useSignOut } from "../lib/session";
import { DropdownMenu } from "./ui/DropdownMenu";

export default function UserChip({ user }: { user: SessionUser }) {
  const signOut = useSignOut();
  const navigate = useNavigate();
  const initial = (user.name ?? user.email).slice(0, 1).toUpperCase();

  return (
    <DropdownMenu>
      <DropdownMenu.Trigger
        aria-label="Account menu"
        className="flex items-center gap-2 rounded-full border border-neutral-800 bg-neutral-900/60 py-1 pr-3 pl-1 outline-none hover:border-neutral-700 focus-visible:border-accent-500 data-[state=open]:border-accent-500"
      >
        {user.avatar_url ? (
          <img
            src={user.avatar_url}
            alt=""
            className="h-6 w-6 rounded-full"
            referrerPolicy="no-referrer"
          />
        ) : (
          <div className="grid h-6 w-6 place-items-center rounded-full bg-neutral-700 text-[11px] font-medium">
            {initial}
          </div>
        )}
        <span className="hidden max-w-[18ch] truncate text-xs text-neutral-300 sm:inline">
          {user.email}
        </span>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        <DropdownMenu.Label>{user.email}</DropdownMenu.Label>
        <DropdownMenu.Separator />
        <DropdownMenu.Item onSelect={() => navigate("/profile")}>
          <UserRound size={13} aria-hidden className="text-neutral-500" />
          <span>Profile</span>
        </DropdownMenu.Item>
        <DropdownMenu.Item onSelect={() => navigate("/profile/location")}>
          <MapPin size={13} aria-hidden className="text-neutral-500" />
          <span>Location preferences</span>
        </DropdownMenu.Item>
        <DropdownMenu.Item onSelect={() => navigate("/settings")}>
          <SettingsIcon size={13} aria-hidden className="text-neutral-500" />
          <span>Settings</span>
        </DropdownMenu.Item>
        <DropdownMenu.Item
          disabled={signOut.isPending}
          onSelect={(e) => {
            e.preventDefault();
            signOut.mutate();
          }}
        >
          <LogOut size={13} aria-hidden className="text-neutral-500" />
          <span>{signOut.isPending ? "Signing out…" : "Sign out"}</span>
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu>
  );
}
